import { render, staticRenderFns } from "./approvalRequests.vue?vue&type=template&id=1192812a&"
import script from "./approvalRequests.vue?vue&type=script&lang=js&"
export * from "./approvalRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports